<template>
  <div>
    <div
      v-if="isDesktop"
      class="announce-bar responsive-visible desktop">
      <span class="announce-bar__content">관리자 체험 모드입니다. 무료 이용 가능한 플랜이 준비되어 있습니다.</span>
      <a
        class="button_buy-now"
        href="https://admin.fiflbox.com/#/register?utm_source=demo_website&utm_medium=topbar_button"
        target="_blank">
        지금 바로 가입
      </a>
    </div>
    <div
      v-else
      class="announce-bar responsive-visible mobile">
      <span class="announce-bar__content">관리자 체험 모드입니다.</span>
      <a
        class="button_buy-now"
        href="https://admin.fiflbox.com/#/register?utm_source=demo_website&utm_medium=topbar_button"
        target="_blank">
        지금 바로 가입
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DemoCenterBar",
    props: {
      isDesktop: {
        type: Boolean,
        default: true,
      },
    },
  }
</script>

<style scoped>

</style>